import { render, staticRenderFns } from "./fapiaoxinxibiangeng.vue?vue&type=template&id=411e70c8&scoped=true&"
import script from "./fapiaoxinxibiangeng.vue?vue&type=script&lang=js&"
export * from "./fapiaoxinxibiangeng.vue?vue&type=script&lang=js&"
import style0 from "./fapiaoxinxibiangeng.vue?vue&type=style&index=0&id=411e70c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411e70c8",
  null
  
)

export default component.exports